<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6">
            Débiteurs
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              size="sm"
              icon
              v-if="$store.getters.isAdmin"
              variant="info"
              :to="{ path: '/debtor/new' }"
              title="Nouveau débiteur"
              ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
            ></b-button>
            <b-button
              v-if="$store.getters.isAdmin"
              size="sm"
              variant="info"
              class="ml-3"
              :href="export_ra"
              target="_blank"
              title="Exporter Recherche Adresse"
              ><b-icon-file-earmark-spreadsheet></b-icon-file-earmark-spreadsheet
            ></b-button>
            <label class="mx-3 align-self-center">Rechercher : </label>
            <mh-input
              @enter="submitSearch(searchTable.search.value, 'all')"
              autofocus
              append="🔍"
              field="search"
              :table="searchTable"
              :autocomplete="
                $store.getters.isAdmin
                  ? {
                      to: { name: 'debtorEdit' },
                      field:
                        'debiteur.ID || debiteur.telephone || debiteur.gsm || debiteur.(nom_soc ID) || debiteur.(nom prenom ID) || debiteur.rue1 || debiteur.rue2 || debiteur.email',
                    }
                  : { to: null, field: null, api: null }
              "
            >
            </mh-input>
            <label class="mx-3 align-self-center">Par numéro : </label>
            <mh-input
              @enter="submitSearch(searchTable.byID.value, 'ID')"
              append="🔍"
              field="byID"
              :table="searchTable"
              :autocomplete="{
                idHistory: 'debtors',
                to: { name: 'debtorEdit' },
                field: 'debiteur.ID',
              }"
            ></mh-input>
          </div>

          <b-row v-if="$options.debtors.length > 0" class="mt-3">
            <b-col sm="12" md="12" lg="12">
              <list
                @changePage="changePage"
                @removeFilter="removeFilter"
                @changeSort="changeSort"
                :fields="fields"
                :search="search"
                :filters="filters"
                :items="$options.debtors"
              >
                <template v-slot:cell(ID)="data">
                  <router-link
                    :to="{
                      name: $store.getters.isAdmin
                        ? 'debtorEdit'
                        : 'debtorView',
                      params: { id: data.item.ID },
                    }"
                    >{{ data.item.ID }}</router-link
                  >
                </template>
                <template v-slot:cell(nom_soc)="data">
                  <router-link
                    :to="{
                      name: $store.getters.isAdmin
                        ? 'debtorEdit'
                        : 'debtorView',
                      params: { id: data.item.ID },
                    }"
                  >
                    <template v-if="data.item.nom_soc != ''">
                      <span v-html="company(data.item.nom_soc)"></span>
                      <template v-if="data.item.nom != ''">
                        (<span
                          v-html="fullName(data.item.prenom, data.item.nom)"
                        ></span
                        >)
                      </template>
                    </template>
                    <template v-else>
                      <span
                        v-html="fullName(data.item.prenom, data.item.nom)"
                      ></span>
                    </template>
                  </router-link>
                </template>
                <template v-slot:cell(gsm)="data">
                  <span v-if="data.item.gsm != ''">{{ data.item.gsm}}</span>
                  <span v-else>{{ data.item.telephone}}</span>
                  
                </template>
                <template v-slot:cell(address)="data">
                  <span v-html="data.item.rue1 + ' ' + data.item.rue2"></span>
                  <span
                    v-html="
                      data.item.codepostal + ' ' + ucfirst(data.item.localite)
                    "
                  ></span>
                </template>
                <template v-slot:cell(mail)="data">
                  <span
                    v-for="(mail, index) in data.item.email.split(';')"
                    :key="index"
                  >
                    <b-link
                      class="mr-2"
                      active
                      target="_blank"
                      :href="'mailto:' + mail"
                    >
                      <span v-html="mail.toLowerCase()"></span>
                    </b-link>
                  </span>
                </template>
                <template v-slot:cell(humDate)="data">{{
                  toDate(data.item.date_creation)
                }}</template>
                <template v-slot:cell(actions)="data">
                  <b-button
                    variant="danger"
                    v-if="$store.getters.isSuperAdmin"
                    @click="deleteDebtor(data.item.ID)"
                    title="Supprimer"
                    size="sm"
                    class="btn-xs"
                    icon
                  >
                    <b-icon-x-circle-fill></b-icon-x-circle-fill>
                  </b-button>
                </template>
              </list>
            </b-col>
          </b-row>
          <b-row v-else-if="loaded" class="mt-3">
            <b-col lg="12">
              <b-alert show>Pas de résultats</b-alert>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import List from "@/components/List";
//import Facets from "@/components/Facets";
import debtors from "@/services/debtors.js";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import MhInput from "@/components/MhInput.vue";

export default {
  components: {
    List,
    MhInput,
  },
  name: "Debtors",
  debtors: [],
  data() {
    return {
      searchTable: {
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
        byID: {
          label: "",
          type: "int",
          value: "",
        },
      },
      debug: false,
      info: {},
      search: this.$route.query.search,
      facets: [],
      filters: [],
      page: 1,
      pagination: {},
      loaded: false,
      resultsInfo: false,
      sortBy: "nom_soc",
      sortDesc: false,
      busy: false,
      actions: [],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Débiteurs",
          active: true,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "#",
          thStyle: "width:100px",
          class: "text-right",
          sortable: true,
        },
        { key: "nom_soc", label: "Nom / société", sortable: true },
        {
          key: "address",
          label: "Adresse",
          sortable: true,
          class: "text-left",
        },
        { key: "gsm", label: "Téléphone / GSM", sortable: false },
        { key: "mail", label: "Email", sortable: true },
        {
          key: "humDate",
          label: "Date",
          sortable: true,
          thStyle: "width:200px",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: "width:100px",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
  },

  computed: {
    export_ra() {
      let url = this.$store.getters.url + "/debtors/ra/export?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      return url;
    },
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },

    deleteDebtor(id) {
      debtors.delete_debtor(id).then((response) => {
        this.$bvToast.toast(response.data.message, {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.submitSearch();
      });
    },
    continueSearch() {
      this.busy = true;
      debtors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          this.activeCreditor
        )
        .then((response) => {
          this.$options.debtors = this.$options.debtors.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch(value = null, field = null) {
      this.busy = true;
      this.page = 1;
      this.filters = [];
      if (value !== null) {
        this.search = value;
      }
      if (field !== null) {
        this.field = field;
      }

      debtors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.debtors = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.loaded = true;
          this.busy = false;
        })
        .catch((error) => {
          console.error(error);
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>